import request from "@/utils/request";
import qs from "qs";

export function getBrandList(params) {
  return request({
    url: "/brand/getList",
    method: "get",
    params
  });
}

export function editBrand(params) {
  return request.post("/brand/editBrand", qs.stringify(params));
}

/**
 * 查询我得品牌列表
 * @param params
 * @returns {AxiosPromise}
 */
export function getMyList(params) {
  return request({
    url: "/brand/getMyList",
    method: "get",
    params
  });
}

/**
 * 审核品牌
 * @param params
 * @returns {*}
 */
export function checkBrand(params) {
  return request.post("/brand/checkBrand", qs.stringify(params));
}
